
        module.exports = __webpack_public_path__ + "assets/images/download.c51d2b86.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 14,
            height: 24,
            type: "png",
            bytes: 445,

            toString: function() {
                return src;
            }
        };
    